module.exports = __webpack_public_path__ + "img/SKMJ_check4.f4f6a3c9.png";